import { Component } from '@angular/core';
import { QuestionnaireService } from './services/questionnaire.service';
import { environment } from '../environments/environment';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [QuestionnaireService]
})
export class AppComponent {
  title = 'demographics-app';
  displayName = environment.displayName;
}
